module.exports = __webpack_public_path__ + "media/images/share-tw-2ae728b901849c465f4f67af4d511f21.svg";